import type { BlogInteractionsData, Note } from "@adafia/types";
import { ThumbsUp } from "lucide-react";

interface PostHeaderProps {
	post: Note;
	interactions?: BlogInteractionsData;
	onLike: () => void;
	isLiking: boolean;
}

export const PostHeader = ({
	post,
	interactions,
	onLike,
	isLiking,
}: PostHeaderProps) => {
	const userHasLiked = interactions?.global.userHasLiked || false;

	return (
		<header className="blog-post-header">
			<div className="blog-meta">
				<span className="blog-date">
					{post.publishedAt
						? new Date(post.publishedAt).toLocaleDateString("en-US", {
								month: "long",
								day: "numeric",
								year: "numeric",
							})
						: "Unpublished"}
				</span>
				<div className="blog-stats">
					<span>{interactions?.global.views || 0} views</span>
					<button
						type="button"
						className={`stats-btn ${userHasLiked ? "liked" : ""}`}
						onClick={onLike}
						disabled={isLiking || userHasLiked}
						title={userHasLiked ? "You liked this post" : "Like this post"}
					>
						<ThumbsUp size={14} /> {interactions?.global.likes || 0}
					</button>
				</div>
			</div>
		</header>
	);
};
